/**
 * Regra de campo obrigatório no frontend (espelho de
 * backend/managers/custom_fields_manager.py:get_contact_required_status).
 *
 * Um campo é obrigatório para o contato quando a etapa atual está em
 * `required_stages` OU o funil da etapa atual está em `required_pipelines`.
 *
 * Usada onde ainda não existe contato no backend para perguntar (criar
 * contato). Na conversa aberta, a fonte continua sendo o endpoint /required.
 */

// Mesmo critério do backend (_is_value_filled).
export function isRequiredValueFilled(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return true;
}

/**
 * Definições obrigatórias para uma etapa/funil.
 *   - stageId: id da etiqueta (etapa) atual, ou null
 *   - pipelineId: id do funil dessa etapa (ou do funil padrão quando não há etapa)
 */
export function requiredDefinitionsFor(definitions, { stageId = null, pipelineId = null } = {}) {
  return (definitions || []).filter((d) => {
    if (!d || d.api_only) return false;
    const stages = d.required_stages || [];
    const pipes = d.required_pipelines || [];
    return (stageId && stages.includes(stageId)) || (pipelineId && pipes.includes(pipelineId));
  });
}

export function missingRequired(definitions, values, scope) {
  return requiredDefinitionsFor(definitions, scope)
    .filter((d) => !isRequiredValueFilled((values || {})[d.id]));
}
